import React from 'react';
import { Card, CardBody, Spinner } from 'reactstrap';

function SopFollowed({ alertsop }) {
  const headerStyle = {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '20px',
    textAlign: 'center',
    padding: '12px',
    borderRadius: '8px',
    color: '#ffffff',
  };

  const followedHeaderStyle = {
    ...headerStyle,
    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
  };

  const notFollowedHeaderStyle = {
    ...headerStyle,
    background: 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)',
  };

  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    borderBottom: '1px solid #f0f0f0',
  };

  const labelStyle = {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333',
    textTransform: 'capitalize',
  };

  const valueStyle = {
    fontSize: '18px',
    fontWeight: '700',
    color: '#2196F3',
    backgroundColor: '#f8f9ff',
    padding: '6px 12px',
    borderRadius: '20px',
    minWidth: '50px',
    textAlign: 'center',
  };

  const containerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '-8px',
  };

  const colStyle = {
    flex: '1 1 300px',
    minWidth: '300px',
    padding: '8px',
  };

  const DataRow = ({ label, value }) => (
    <div style={rowStyle}>
      <span style={labelStyle}>{label}:</span>
      <span style={valueStyle}>
        {value === undefined ? <Spinner size="sm" color="primary" /> : value}
      </span>
    </div>
  );

  const StatCard = ({ title, data, isFollowed }) => {
    const followedKey = isFollowed ? 'sop_followed' : 'sop_unfollowed';

    const total =
      (data?.blacklisted?.entries?.[followedKey] || 0) +
      (data?.employee?.entries?.[followedKey] || 0) +
      (data?.contractor?.entries?.[followedKey] || 0) +
      (data?.unknown?.entries?.[followedKey] || 0);

    return (
      <div style={colStyle}>
        <Card
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            transition: '0.3s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
          }}
        >
          <CardBody>
            <div style={isFollowed ? followedHeaderStyle : notFollowedHeaderStyle}>
              {title}
            </div>
            <DataRow label="Total" value={total} />
            <DataRow label="Employee" value={data?.employee?.entries?.[followedKey]} />
            <DataRow label="Contractor" value={data?.contractor?.entries?.[followedKey]} />
            <DataRow label="Unknown" value={data?.unknown?.entries?.[followedKey]} />
            <DataRow label="Blacklist" value={data?.blacklisted?.entries?.[followedKey]} />
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div style={containerStyle}>
      <StatCard title="SOP Followed" data={alertsop} isFollowed={true} />
      <StatCard title="SOP Not Followed" data={alertsop} isFollowed={false} />
    </div>
  );
}

export default SopFollowed;
